import { useTranslate } from "../contexts/translate";
import { CardProps } from "./Card";
import styled from "styled-components";
import { Subheader } from "./ui/Subheader";

function getIconFilename(icon: string) {
  if (icon.startsWith("swas")) {
    return "SWas.png";
  }
  if (icon.startsWith("troop")) {
    return "Troop.png";
  }
  if (icon.startsWith("terrain")) {
    return "Terrain.png";
  }
  if (icon.startsWith("action")) {
    return "Action.png";
  }
  if (icon.startsWith("nation")) {
    return "Nation.png";
  }
}

const Icon = styled.span<{ icon: string }>`
  display: block;
  height: 100%;
  aspect-ratio: 1;
  background: url("/assets/ui/cards/${({ icon }) => getIconFilename(icon)}");
  background-size: contain;
  background-repeat: no-repeat;
`;

const Arrow = styled.button<{ dir: "left" | "right" }>`
  width: calc(0.5 * 50 * var(--u) * 259 / 1512);
  height: calc(0.5 * 50 * var(--u) * 259 / 1512);
  background: url("/assets/ui/Nav-Arrow ${({ dir }) => dir}.png");
  background-size: contain;
  background-repeat: no-repeat;

  &[disabled] {
    opacity: 0.5;
  }
`;

const Title = styled.div`
  width: calc(50 * var(--u));
  height: calc(50 * var(--u) * 259 / 1512);
  display: flex;
  flex-direction: row;
  align-items: center;

  span.label {
    display: block;
    flex-grow: 1;
    text-align: center;
    color: black;
    font-size: calc(4 * var(--u));
  }
`;

const Hint = styled.p`
  color: black;
  font-style: italic;
  margin: 0;
  font-size: calc(3 * var(--u));

  @media (orientation: landscape) {
    display: none;
  }
`;

export function CardSubheader(props: {
  card: CardProps;
  onNavigate: (card?: CardProps) => void;
  prevCard?: CardProps;
  nextCard?: CardProps;
}) {
  const { translate } = useTranslate();

  if (!props.card) {
    return null;
  }

  return (
    <>
      <Subheader>
        <Arrow
          dir="left"
          disabled={!props.prevCard}
          onClick={() => props.onNavigate(props.prevCard)}
        />
        <Title>
          <Icon icon={props.card.type} />
          <span className="label">
            {translate(
              `components.CardSubheader.${props.card.type}CardsTitle`,
              {
                id: props.card.id,
              }
            )}
          </span>
        </Title>
        <Arrow
          dir="right"
          disabled={!props.nextCard}
          onClick={() => props.onNavigate(props.nextCard)}
        />
      </Subheader>
      <Hint>{translate("components.CardSubheader.info")}</Hint>
    </>
  );
}
